import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./About.module.scss";
export default function AboutLicense() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>License</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Row><Col className={`${styles.lastUpdateText} text-right pt-3 pb-3`}>Last Updated: February 23, 2023</Col></Row>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p><b>The Memes and Meme Lab</b></p>;
    t3 = <p>The Memes and Meme Lab NFTs are released by the artists under a Creative Commons 0 (CC0) license, which is a public domain license. The author or authors of The Memes and Meme Lab NFTs are renouncing any copyright in The Memes and Meme Lab NFTs to the maximum extent allowed by law.</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p>Link to the formal text of the CC0 license:{" "}<Link href="https://creativecommons.org/share-your-work/public-domain/cc0/" target="_blank" rel="noopener noreferrer">https://creativecommons.org/share-your-work/public-domain/cc0/</Link></p>;
    t5 = <p>This means that, whether or not you own a The Memes or Meme Lab NFT, the artists don't mind if you use the art of The Memes or Meme Lab NFT for whatever purpose you like, for commercial or non-commercial use, without any requirement to seek permission from them.</p>;
    t6 = <p>The community term for derivative works based on The Memes is "ReMemes", but you do not have to call your work ReMemes. The goal is for the messages embodied in the Meme Cards to spread around the world, to different people, in different cultures and countries, who speak different languages and have different cultural contexts.</p>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Container>{t0}{t1}<Row className="pt-3 pb-3"><Col>{t2}{t3}{t4}{t5}{t6}<p>It is possible that some Meme Cards contain copyrighted elements that are not in the public domain. For example, Meme Card #1 is a derivative of Punk 6529, the copyright for which is owned by Yuga Labs. @<Link href="https://x.com/6529er" target="_blank" rel="noopener noreferrer">6529er</Link>{" "}, the artist, is putting whatever rights he may have in Meme Card #1 in the public domain. That means if you use Meme Card #1, he will not pursue any claims against you. But he does not have the right to put Punk 6529 into the public domain (only Yuga Labs can do that). He also cannot authorize use of trademark "Cryptopunks" - the trademark is also owned by Yuga Labs.</p><p>Neither 6529 Collection LLC nor the artists are responsible for damages you may suffer for infringement on the rights of third parties.</p><br /><p><b>6529 Gradient</b></p><p>In general, we do not mind if people use the Gradient NFTs as we have seen them used in some art and memes, but we are concerned about people impersonating 6529 (for example, to operate a phishing website).</p><p>Please do not use the Gradient NFTs in a way that could lead to confusion about whether any product or service you are selling is offered by 6529. For these reasons, we are treating the Gradient NFTs differently from The Memes and Meme Lab NFTs at this point in time. The Gradient NFTs have not, at this point in time, been released under the CC0 license.</p><p>We are working on a more detailed policy to give more clarity around how people can use the Gradient NFTs without getting further permissions in advance, but, until then, we reserve all "IP" rights in the Gradient NFTs. No "IP rights" have ever been promised to Gradient collectors and Gradient collectors should not buy a Gradient based on the expectation of any "IP rights" being available.</p></Col></Row></Container>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}